import Amplify, { Auth } from 'aws-amplify';
import config from 'src/config';

Amplify.configure({
  aws_project_region: config.cognitoProjectRegion,
  aws_cognito_region: config.cognitoRegion,
  aws_user_pools_id: config.cognitoPoolId,
  aws_user_pools_web_client_id: config.cognitoClientId,
  oauth: {
    domain: config.cognitoDomain,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: `${window.location.origin}/`,
    redirectSignOut: `${window.location.origin}/logout`,
    responseType: 'code',
  },
  Auth: {
    identityPoolId: config.cognitoIdentityPoolId,
  },
});

export { Auth };
